@if (loading()) {
  <div class="loading-container">
    <mat-spinner diameter="32"></mat-spinner>
    <span>Loading modules...</span>
  </div>
}

@if (error(); as errorMsg) {
  <div class="error-message">
    <mat-icon>error</mat-icon>
    <span>{{ errorMsg }}</span>
    <button mat-button color="primary" (click)="loadModules()">Retry</button>
  </div>
}

@if (isEmpty()) {
  <div class="empty-state">
    <mat-icon class="empty-icon">extension</mat-icon>
    <h3>No modules installed</h3>
    <p>Use the CLI to upload a module to this project:</p>
    <code>ehq module push</code>
  </div>
} @else if (!loading()) {
  <table mat-table [dataSource]="modules()" class="modules-table">
    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let module">
        <button mat-button color="primary" (click)="viewDetails(module)" class="module-name-btn">
          {{ module.name }}
        </button>
      </td>
    </ng-container>

    <!-- Version Column -->
    <ng-container matColumnDef="version">
      <th mat-header-cell *matHeaderCellDef>Version</th>
      <td mat-cell *matCellDef="let module">{{ module.version }}</td>
    </ng-container>

    <!-- Description Column -->
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef>Description</th>
      <td mat-cell *matCellDef="let module">{{ module.description }}</td>
    </ng-container>

    <!-- Functions Column -->
    <ng-container matColumnDef="functions">
      <th mat-header-cell *matHeaderCellDef>Functions</th>
      <td mat-cell *matCellDef="let module">{{ functionCount(module) }}</td>
    </ng-container>

    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let module">
        <button mat-icon-button [matMenuTriggerFor]="menu" matTooltip="Actions">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="viewDetails(module)">
            <mat-icon>info</mat-icon>
            <span>View Details</span>
          </button>
          <button mat-menu-item (click)="confirmDelete(module)" class="delete-action">
            <mat-icon color="warn">delete</mat-icon>
            <span>Remove</span>
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
}
